import { css } from '@emotion/react';

import { theme } from '../theme';

export const wrapper = css`
  width: 100%;
  height: 100%;
  display: flex;
  gap: '0';
`;
export const logo = css`
  display: flex;
  align-items: center;
  margin-right: ${theme.spacing.lg};
  margin-left: ${theme.spacing.sm};
  @media (max-width: ${theme.breakpoints.laptop}) {
    display: none;
  }
`;

export const sasLogoLink = css`
  cursor: pointer;
`;

export const backLinkWrapper = css`
  display: none;
  @media (max-width: ${theme.breakpoints.laptop}) {
    display: flex;
    align-items: center;
    width: 80px;
  }
`;

export const backLink = css`
  padding: ${theme.spacing.md};
  svg {
    color: ${theme.colors.white};
  }
`;

export const mobileTitle = css`
  display: none;
  @media (max-width: ${theme.breakpoints.laptop}) {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }
`;

export const mobileTitleSmall = css`
  font: ${theme.typography.pRebook};
`;

export const links = css`
  flex: 1;
  align-items: stretch;
  display: flex;

  @media (max-width: ${theme.breakpoints.laptop}) {
    display: none;
  }
`;

export const linkItem = (isSelected: boolean, isLink: boolean) => css`
  color: ${theme.colors.white};
  padding: 0 ${theme.spacing.lg};
  display: flex;
  align-items: center;
  background-color: ${isSelected ? theme.colors.primaryHover : 'transparent'};
  text-decoration: none;
  opacity: ${isSelected || isLink ? 1 : 0.5};

  &:hover {
    color: ${theme.colors.white} !important;
    text-decoration: ${!isSelected && isLink ? 'underline' : 'none'};
  }
`;

export const closeIcon = css`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    color: ${theme.colors.white};
  }
`;
